import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Avatar,
  Tooltip,
  IconButton,
  useTheme,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';

const Header = ({ user, onSignOut }) => {
  const theme = useTheme();

  // user is the Cognito user object from getCurrentUser()
  const username = user?.username || user?.signInDetails?.loginId || 'User';

  const handleLogout = async () => {
    if (window.confirm('Are you sure you want to sign out?')) {
      await onSignOut();
    }
  };

  return (
    <AppBar position="static" elevation={2} sx={{ bgcolor: 'background.paper' }}>
      <Toolbar sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="h6" component="div" fontWeight={600} color="primary">
            Sensor Dashboard
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Tooltip title={username}>
            <Avatar sx={{ bgcolor: 'primary.main', width: 36, height: 36 }}>
              <PersonIcon />
            </Avatar>
          </Tooltip>

          <Typography variant="body1" color="text.primary" sx={{ minWidth: 100 }}>
            {username}
          </Typography>

          <Button
            variant="outlined"
            color="error"
            startIcon={<LogoutIcon />}
            onClick={handleLogout}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 500,
            }}
          >
            Sign Out
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;